import { gql } from '@apollo/client'

export const createProduct_billOfMaterials_with_parent_product = gql`
  mutation createProduct_billOfMaterials_with_parent_product($filter: JSON!, $input: JSON!) {
    createProduct_billOfMaterials_with_parent_product(input: $input, filter: $filter) {
      _id
      name
      code
      fullBillOfMaterials
    }
  }
`

export const updateProduct_billOfMaterials_with_parent_product = gql`
  mutation updateProduct_billOfMaterials_with_parent_product($filter: JSON!, $input: JSON!) {
    updateProduct_billOfMaterials_with_parent_product(input: $input, filter: $filter) {
      _id
      name
      code
      fullBillOfMaterials
    }
  }
`

export const deleteProduct_billOfMaterials_with_parent_product = gql`
  mutation deleteProduct_billOfMaterials_with_parent_product($filter: JSON!) {
    deleteProduct_billOfMaterials_with_parent_product(filter: $filter) {
      _id
      name
      code
      fullBillOfMaterials
    }
  }
`
